// Supported tags for copy assist
export enum CopyAssistTagNames {
  TextArea = 'textarea',
  Input = 'input',
  WhatsAppTextArea = 'whatsapp_textarea',
  InputWithNoTriggerIcon = 'input_with_no_trigger',
}
